import React, { useEffect, useState } from 'react';
import NavigationBar from '../NavigationBar';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import SideBarUser from '../SideBarUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { useUser } from '../../auth/UseUser';
import NavBar from '../NavBar';
import SinglePuskica from '../puskice/SinglePuskica';
import PhoneFooter from '../PhoneFooter';

function UserHome() {
    const navigate = useNavigate();
    const { isSignedIn, setTipEtiteta, setSelectedPitanje, showSelectedPuskica, navLista, setNavLista, returnedList, setReturnedList } = useUser();
    const [isOpen, setIsopen] = useState(false);
    const location = useLocation();

    if (location.pathname === '/') {
        return <Navigate to="/home" replace />;
    }

    // stranice bez bočnog menija sa kategorijama
    const isInfoPage = ['home', 'terms', 'privacy', 'contact'].some((name) => location.pathname.includes(name));

    const handleSelect = (item: any) => {
        if (item?.tip === TypeOfEtity.Kategorija) {
            navigate(`/user/kategorija/${item?.id}`);
        }
        if (item?.tip === TypeOfEtity.Podkategorija) {
            navigate(`/user/podkategorija/${item?.id}`);
        }
        if (item?.tip === TypeOfEtity.SkupOblasti) {
            navigate(`/user/skup-oblasti/${item?.id}`);
        }
        if (item?.tip === TypeOfEtity.Oblast) {
            navigate(`/user/oblast/${item?.id}`);
        }
        if (item?.tip === TypeOfEtity.Podoblast) {
            navigate(`/user/podoblast/${item?.id}`);
        }
        if (item?.tip === TypeOfEtity.Lekcija) {
            navigate(`/user/lekcija/${item?.id}`);
            setIsopen(false);
        }
        if (item?.tip === TypeOfEtity.Pitanje) {
            setSelectedPitanje(item);
        }
        if (item?.naziv === 'Klasik') {
            navigate(`/user/kviz/klasik`);
            setIsopen(false);
        }
        if (item?.naziv === 'Lovac - Vežbanje') {
            navigate(`/user/kviz/lovac`);
            setIsopen(false);
        }
        if (item?.naziv === 'Lovac - Takmičarski') {
            navigate(`/user/kviz/lovac/takmicarski`);
            setIsopen(false);
        }
    };

    const handleNavLista = (item: any) => {
        if (item === null) {
            navigate(`/`);
            return;
        } else {
            loadSelectedList(item);
        }
    };

    function loadSelectedList(item: any) {
        switch (item?.tip) {
            case TypeOfEtity.Kategorija:
                navigate(`/user/kategorija/${item?.id}`);
                break;
            case TypeOfEtity.Podkategorija:
                navigate(`/user/podkategorija/${item?.id}`);
                break;
            case TypeOfEtity.SkupOblasti:
                navigate(`/user/skup-oblasti/${item?.id}`);
                break;
            case TypeOfEtity.Oblast:
                navigate(`/user/oblast/${item?.id}`);
                break;
            case TypeOfEtity.Podoblast:
                navigate(`/user/podoblast/${item?.id}`);
                break;
        }
    }

    const toggleSidebar = () => {
        console.log('toggle');
        isOpen === true ? setIsopen(false) : setIsopen(true);
    };

    return (
        <div className=" w-full min-h-dvh lg:h-dvh relative bg-blueDark lg:bg-greenA200">
            <div className="sticky top-0 z-[10] lg:static">
                <NavBar toggleSideBar={toggleSidebar} />
            </div>
            <div className=" w-full lg:h-[calc(100%-70px)]">
                {location.pathname.includes('kviz') ? (
                    <div className="w-full h-[1px] bg-gold"></div>
                ) : isInfoPage ? null : (
                    <div className="sticky top-[70px] z-[9] lg:static">
                        <NavigationBar navLista={navLista} handleNavLista={handleNavLista} />
                    </div>
                )}
                <div
                    className={`${location.pathname.includes('kviz') ? 'lg:h-[calc(100%-1px)]' : isInfoPage ? 'lg:h-full' : 'lg:h-[calc(100%-36px)]'} flex flex-row relative`}
                >
                    {isInfoPage ? null : (
                        <SideBarUser sideBarList={returnedList} toggleSideBar={toggleSidebar} backbutton={true} isOpen={isOpen} handleSelect={handleSelect} />
                    )}

                    {/* Na mobilnom skroluje cela stranica (Safari tada sakriva donju traku); na desktopu skroluje ovaj kontejner */}
                    <div
                        className={`bg-blueDark lg:bg-gold w-full lg:h-full lg:overflow-auto flex flex-row pb-[70px] lg:pb-0 ${location.pathname.includes('kviz') ? 'min-h-[calc(100dvh-71px)]' : isInfoPage ? 'min-h-[calc(100dvh-70px)]' : 'min-h-[calc(100dvh-106px)]'} lg:min-h-0`}
                    >
                        <div className="flex-1 flex flex-col lg:block bg-blueDark lg:bg-blueSuperLight">
                            <Outlet />
                        </div>
                        {showSelectedPuskica && <SinglePuskica />}
                    </div>
                    <PhoneFooter setIsOpen={setIsopen} />
                </div>
            </div>
        </div>
    );
}

export default UserHome;
